import { useCallback } from "react";

import { generateState, OAUTH_STATE_KEY } from "Auth/Utils/oauth";

const ENTRA_ID_CONFIG = {
	clientId: import.meta.env.VITE_ENTRA_ID_CLIENT_ID || "",
	tenantId: import.meta.env.VITE_ENTRA_ID_TENANT_ID || "",
	redirectUri: `${globalThis.location.origin}/auth/callback`,
	scopes: ["openid", "profile", "email", "offline_access"],
};

export function useEntraIdLogin() {
	const initiateLogin = useCallback(() => {
		const { clientId, tenantId, redirectUri, scopes } = ENTRA_ID_CONFIG;

		if (!clientId || !tenantId) {
			console.error("Entra ID configuration is missing");
			return;
		}

		// Generate state for CSRF protection
		const state = generateState();

		// Store in sessionStorage for validation in callback
		sessionStorage.setItem(OAUTH_STATE_KEY, state);

		// Build authorization URL
		const authUrl = new URL(
			`https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize`,
		);
		authUrl.searchParams.set("client_id", clientId);
		authUrl.searchParams.set("response_type", "code");
		authUrl.searchParams.set("redirect_uri", redirectUri);
		authUrl.searchParams.set("scope", scopes.join(" "));
		authUrl.searchParams.set("response_mode", "query");
		authUrl.searchParams.set("state", state);

		// Redirect to Microsoft login
		globalThis.location.href = authUrl.toString();
	}, []);

	const isConfigured = Boolean(
		ENTRA_ID_CONFIG.clientId && ENTRA_ID_CONFIG.tenantId,
	);

	return { initiateLogin, isConfigured };
}
